import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Card } from '@totalsoft/rocket-ui';
import { LogPropertyContainer } from 'features/logs/components/LogStyles';
import EvaluationLogXmlContentContainer from './EvaluationLogXmlContentContainer';

const EvaluationLogComponent = ({ data }) => {
  const { t } = useTranslation();

  return (
    <Card disablePadding>
      <Grid container>
        <Grid item container alignItems={'center'} pt={2} pb={1} px={3} xs={11} id={`evaluationLogItem_${data.id}`} spacing={1}>
          <LogPropertyContainer item xs={6} lg={3}>
            <span title={data.documentNumber}>
              <strong>{t('EvaluationLogs.ID')}:</strong>
              {data.id}
            </span>
          </LogPropertyContainer>

          <LogPropertyContainer item xs={6} lg={3}>
            <span title={data.documentNumber}>
              <strong>{t('EvaluationLogs.CorrelationID')}:</strong>
              {data.correlationID}
            </span>
          </LogPropertyContainer>

          <LogPropertyContainer item xs={6} lg={3}>
            <span title={data.documentNumber}>
              <strong>{t('EvaluationLogs.Entity_PK1')}:</strong>
              {data.entity_PK1}
            </span>
          </LogPropertyContainer>

          <LogPropertyContainer item xs={6} lg={3}>
            <span title={data.documentNumber}>
              <strong>{t('EvaluationLogs.Entity_PK2')}:</strong>
              {data.entity_PK2}
            </span>
          </LogPropertyContainer>

          <LogPropertyContainer item xs={6} lg={3}>
            <span title={data.documentNumber}>
              <strong>{t('EvaluationLogs.EntityType')}:</strong>
              {data.entityType}
            </span>
          </LogPropertyContainer>

          <LogPropertyContainer item xs={6} lg={3}>
            <span title={data.timeUtc}>
              <strong>{t('EvaluationLogs.TimeUtc')}:</strong>
              {data.timeUtc}
            </span>
          </LogPropertyContainer>

          <LogPropertyContainer item xs={6} lg={3}>
            <span title={data.source}>
              <strong>{t('EvaluationLogs.Source')}:</strong>
              {data.source}
            </span>
          </LogPropertyContainer>

          <LogPropertyContainer item xs={6} lg={3}>
            <span title={data.additionalInfo}>
              <strong>{t('EvaluationLogs.AdditionalInfo')}:</strong>
              {data.additionalInfo}
            </span>
          </LogPropertyContainer>
        </Grid>
        <Grid item container xs={1}>
          <Grid item container xs={12} justifyContent='end' alignSelf='center' pr={2}>
            <EvaluationLogXmlContentContainer id={data.id} />
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

EvaluationLogComponent.propTypes = {
  data: PropTypes.object.isRequired
};

export default EvaluationLogComponent;
